import { render, staticRenderFns } from "./SpecialCampaign.vue?vue&type=template&id=98b2d6d0&scoped=true&"
import script from "./SpecialCampaign.vue?vue&type=script&lang=js&"
export * from "./SpecialCampaign.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCampaign.vue?vue&type=style&index=0&id=98b2d6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b2d6d0",
  null
  
)

export default component.exports